module.exports = __webpack_public_path__ + "media/honey-icons/icon-philips-hue-bridge-f605281e.svg";